import { TFunction } from 'i18next';
import { CalendarEventType, DocumentType } from '@/features/calendar/types/calendar-dto';
import { CalendarConfig } from '@/features/calendar/utils/CalendarConfig';
import { BookingStatus } from '@/features/superAdmin/features/data/types/superAdmin-data.types';

const getDocumentTypeLabelKey = (documentType: DocumentType): string => {
    switch (documentType) {
        case DocumentType.Reservation:
            return 'main.calendar.eventTypes.reservation';
        case DocumentType.Accommodation:
            return 'main.calendar.eventTypes.accommodation';
        default:
            return 'main.calendar.eventTypes.unknown';
    }
};

const getBookingStatusLabelKey = (status: BookingStatus): string => {
    switch (status) {
        case BookingStatus.Pending:
            return 'superAdmin.data.bookings.status.pending';
        case BookingStatus.New:
            return 'superAdmin.data.bookings.status.new';
        case BookingStatus.Ongoing:
            return 'superAdmin.data.bookings.status.ongoing';
        case BookingStatus.Cancelled:
            return 'superAdmin.data.bookings.status.cancelled';
        default:
            return 'main.calendar.eventTypes.unknown';
    }
};

export const getEventTypeLabel = (eventType: CalendarEventType, t: TFunction): string =>
    t(CalendarConfig.getEventNameKey(eventType));

export const getDocumentTypeLabel = (documentType: DocumentType, t: TFunction): string =>
    t(getDocumentTypeLabelKey(documentType));

export const getBookingStatusLabel = (status: BookingStatus | number, t: TFunction): string =>
    t(getBookingStatusLabelKey(status as BookingStatus));
